module.exports = __webpack_public_path__ + "static/media/icn_outside_india_fisdom.0c454f80.svg";